import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import ErrorLayout from "./ErrorLayout";

function Error404() {
	return (
		<ErrorLayout>
			<PageTitle title="Page Not Found - OMIQ" />
			<Heading Tag="h1" size="xl" center className="mb-6 text-color-3">
				Not Found
			</Heading>
			<Paragraph size="s" center>
				We’re sorry. The requested resource was not found.
			</Paragraph>
		</ErrorLayout>
	);
}

export default Error404;
